import { PayloadAction } from '../../../store.model';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: MainState,
    action: PayloadAction<ActionType.EVAL_MAIN__RELOAD, Reload>,
): MainState {
    return {
        ...state,
        pending: {
            ...state.pending,
            reload: true,
        },
        templateVersions: undefined,
        selectedUser: {
            value: action.payload.user,
            initialLoad: true,
        },
        selectedTemplateVersionId: {
            value: action.payload.templateVersionId,
            initialLoad: true,
        },
    };
}

export function reloadResultReducer(
    state: MainState,
    action: PayloadAction<ActionType.EVAL_MAIN__RELOAD_RESULT, ReloadResult>,
): MainState {
    try {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            templateVersions: action.payload.templateVersions,
            didInitialLoad: true,
        };
    } catch {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
        };
    }
}
